import { render } from "./EmailTemplateDetail.vue?vue&type=template&id=a55ae670"
import script from "./EmailTemplateDetail.vue?vue&type=script&lang=js"
export * from "./EmailTemplateDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__